<template>
    <div class="list">

      <div class="banner" v-if="show">
        <img :src="data.bannerUrl" alt="">
<!--        <h2>套餐类型</h2>-->
      </div>

      <template v-if="list.length != 0">
        <ul class="list_ul" :class=" show ? '' : 'all_height' " >
          <mu-load-more :loaded-all="loadall" :loading="loading" @load="load">
            <li v-for="item in list" :key="item.id" @click="link(item)" >
              <img :src="item.thumbnail" alt="">
              <div class="list_item">
                <h2>{{ item.productName }}</h2>
                <p class="list_item_p1">{{ item.subhead }}</p>
                <p class="list_item_p2">¥ {{ item.price }}</p>
              </div>
            </li>
          </mu-load-more>
        </ul>
      </template>

      <template v-else>
        <NoList>
          <template #text>
            <p>暂无数据</p>
          </template>
        </NoList>
      </template>

    </div>
</template>

<script>
export default {
    name: "List",
    data() {
      return {
        list_json: {
          productCategory: null,
          pageNum: 1,
          pageSize: 10,
        },
        data: {

        },
        list: [],
        loadall: false,
        loading: false,
        show: true
      }
    },
    created() {

      if(this.$route.query.screen) {
        let screen= JSON.parse(this.$route.query.screen);
        console.log(screen)
        document.title= screen.name;
        this.list_json[screen.data] = screen.state;
        this.show= false;
        this.get_list(this.list_json);
      }

      if(this.$route.query.id) {
        this.list_json.productCategory= this.$route.query.id;
        this.get_list(this.list_json);
      }
    },
    mounted() {

    },
    methods: {
      load() {
        console.log("load");
        this.loading= true;
        this.list_json.pageNum= this.list_json.pageNum + 1;
        this.get_list(this.list_json);
      },
      get_list(y) {
        this.$get("product",y)
          .then(res => {
            if(res) {
              this.loadall= !res.data.pageInfo.hasNextPage;
              this.loading= false;

              this.data= res.data;

              res.data.pageInfo.list.forEach((item) => {
                this.list.push(item);
              })

            }
          })
      },
      link(e) {
        this.$router.push({
          path: "/Deta",
          query: {
            id: e.productId,
            thumbnail: e.thumbnail,
            productName: e.productName,
          }
        })
      }
    }
}
</script>

<style lang="less" scoped>
  .all_height{
    height: 100% !important;
  }
  @import "../../../style/Make/MakeListDeta/List";
</style>
